

export const CilpronApi = {
  BASE_URL: 'https://global.cilpron.com/api',
  TOKEN_KEY: 'cilpron_token',
  TENANT_TOKEN_KEY: 'cilpron_tenant_token',
  API_KEY: 'cilpron_api_key',

  ENDPOINTS: {
    LOGIN:        '/User/login',
    LOGOUT:       '/User/logout',
    PROFILE:      '/User/profile',
    ACCESS_TOKEN: (userId: string) => `/AccessToken/User/${userId}`,
  },
} as const;
export const IMAGES = [
    { id: 0, imageurl: "" },
    { id: 1, imageurl:  ""},
    { id: 2, imageurl: "" },
    { id: 3, imageurl: "" },
    { id: 4, imageurl:  ""},
    { id: 5, imageurl: "" },
];


export const slideTextContent = [
    {
        heading: "Empowering Your Digital Transformation",
        subheading: "From Concept to Completion",
        text: "We provide innovative software solutions that drive efficiency and growth. Partner with us to elevate your business to new heights.",

        buttonText: "Learn More",
        buttonLink: "/solutions"
    },
    {
        heading: "Your Success, Our Commitment",
        subheading: "Innovative Solutions for Every Challenge",
        text: "We collaborate with you at every step, ensuring our software meets your unique needs and propels your success.",

        buttonText: "Learn More",
        buttonLink: "/solutions"
    },
    {
        heading: "Transforming Ideas into Reality",
        subheading: "Custom Software for Your Unique Needs",
        text: "Our team of experts crafts tailored software solutions that streamline operations and enhance productivity.",

        buttonText: "Learn More",
        buttonLink: "/solutions"
    },
    {
        heading: "Fueling Your Growth",
        subheading: "Innovate, Integrate, Succeed",
        text: "We deliver cutting-edge technology that empowers your business to thrive in a competitive landscape.",

        buttonText: "Learn More",
        buttonLink: "/solutions"
    },
    {
        heading: "Technology at Your Fingertips",
        subheading: "Seamless Solutions for Modern Needs",
        text: "Our intuitive software solutions are designed to simplify your life, whether you're at the office or on the go.",

        buttonText: "Learn More",
        buttonLink: "/solutions"
    },
    {
        heading: "Security You Can Trust",
        subheading: "Protecting Your Data, Ensuring Peace of Mind",
        text: "We utilize the latest security technologies to safeguard your information, allowing you to focus on what matters most.",

        buttonText: "Learn More",
        buttonLink: "/solutions"
    },
    
];
